import { render } from "./NextFrame.vue?vue&type=template&id=7d7efca4&scoped=true&ts=true&lang=pug"
import script from "./NextFrame.vue?vue&type=script&lang=ts"
export * from "./NextFrame.vue?vue&type=script&lang=ts"

import "./NextFrame.vue?vue&type=style&index=0&id=7d7efca4&scoped=true&lang=css"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7efca4"]])

export default __exports__